import { useEffect, useState } from 'react';
import TableBackground from '../../components/Background/TableBackground';
import Diary from './Diary';
import './epilogue.css';
import BackButton from '../../components/Button/IconButton/BackButton';

interface EpilogueProps {
    goToMenuCb: () => void;
}

function Epilogue(props: EpilogueProps) {
    const { goToMenuCb } = props;
    const [showThanks, setShowThanks] = useState(false);

    useEffect(() => {
        setTimeout(() => {
            setShowThanks(true);
        }, 13200);
    }, []);

    return (
        <TableBackground>
            <div
                className="epilogue"
                onClick={showThanks ? goToMenuCb : undefined}
            >
                {showThanks && <BackButton onClick={goToMenuCb} />}
                <Diary isIntro={false} />
                {showThanks && (
                    <div className="thanks">
                        Thanks for
                        <br />
                        playing!
                    </div>
                )}
            </div>
        </TableBackground>
    );
}

export default Epilogue;
